export default __webpack_public_path__ + "static/media/xmines_nathanyell_exited.4fe6c302.mp3";